import React, { useContext, useEffect, useState } from "react";
import {
  InputBase,
  Divider,
  InputAdornment,
  TextField,
  Backdrop,
  Grid,
  useMediaQuery,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  Paper,
  Typography,
  Tooltip,
  Zoom,
} from "@mui/material";
import ReactPlayer from "react-player";
import {
  motion,
  useMotionValue,
  useAnimationFrame,
  useTransform,
  wrap,
} from "framer-motion";
import Alert from "@mui/material/Alert";
import escudo from "../components/escudo.png";
import { ContextSession } from "../services/ContextSession";
import { useNavigate } from "react-router-dom";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import previa from "./img/previa.png";
import qys from "../components/qys.png";
import cotizaciones from "../components/1cotizaciones.png";
import constanciacotizaciones from "../components/constanciacotizaciones.png";
import constancias from "../components/constancia.png";
import constanciaPrestaciones from "../components/constancia-prestaciones.png";
import preanalisis from "../components/preanalisis.png";
import axios from "axios";
import { DialogActions, DialogTitle } from "@mui/material";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import SearchIcon from "@mui/icons-material/Search";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ArticleIcon from "@mui/icons-material/Article";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import ErrorIcon from "@mui/icons-material/Error";
import SavingsIcon from "@mui/icons-material/Savings";
import proyectados from "../components/revalorizacion-pensionados.png";
import noprestamos from "../components/noprestamos.png";
import embajada from "../components/embajada.png";
import razonada from "../components/razonada.png";
import ScrollableCardRow from "./cardsInicio";
import MenuIcon from "@mui/icons-material/Menu";
import DirectionsIcon from "@mui/icons-material/Directions";

const SHOW_REVALORIZACION_CARD = true;
const REVALORIZACION_NOTICE_STORAGE_KEY = "revalorizacionNoticeShown";

const ParallaxText = ({ children, baseVelocity = 10 }) => {
  const baseX = useMotionValue(0);

  useAnimationFrame((t, delta) => {
    const moveBy = baseVelocity * (delta / 1000);
    baseX.set(baseX.get() + moveBy);
  });

  const x = useTransform(baseX, (v) => `${wrap(-100, 100, v)}%`);

  return (
    <div
      style={{
        overflow: "hidden",
        maxWidth: "81vw",
        width: "100%",
        whiteSpace: "nowrap",
      }}
    >
      <motion.div style={{ display: "inline-flex", x }}>
        <span>{children}</span>
      </motion.div>
    </div>
  );
};

const filterCriteria = {
  Préstamos: "Préstamo",
  Constancias: "Constancia",
  Cotizaciones: "Cotizaciones",
  "Quejas y Sugerencias": "Queja",
};

export default function PantallaInicio() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const videoUrl = "https://www.youtube.com/watch?v=E09tOIKZvV0";
  const navigate = useNavigate();
  const sessi = useContext(ContextSession);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogOpenJubilados, setDialogOpenJubilados] = useState(false);
  const [dialogOpenCotizaciones, setDialogOpenCotizaciones] = useState(false);
  const [dialogOpenRevalorizacion, setDialogOpenRevalorizacion] =
    useState(false);
  const [filterActive, setFilterActive] = useState(false); // Indica si hay un filtro activo
  const [startIndex, setStartIndex] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);

    // Filtrar los cards según la búsqueda
    const filtered = initialCards.filter(
      (card) =>
        card.title.toLowerCase().includes(value.toLowerCase()) ||
        card.description.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCards(filtered);
  };

  const handleFilter = (filterName) => {
    const filterKeyword = filterCriteria[filterName];
    if (filterKeyword) {
      const filtered = initialCards.filter((card) =>
        card.title.toLowerCase().includes(filterKeyword.toLowerCase())
      );
      setFilteredCards(filtered);
      setFilterActive(true);
      setStartIndex(0); // Reinicia el índice al aplicar filtro
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleClearFilters = () => {
    setFilteredCards(initialCards); // Restaura todos los cards
    setFilterActive(false); // Desactiva el estado del filtro
    // Desplaza hacia la parte superior
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleButtonClickPreanalisis = async () => {
    try {
      const response = await axios.get(
        `${sessi.ip}/solicitudesMes/${sessi.sessionData.id}/`,
        //`http://172.20.7.10:8082/solicitudesMes/${sessi.sessionData.id}/`,
        {
          headers: {
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
        }
      );

      const { cantSolicitudesMes, cantSolicitudActiva } = response.data;

      if (cantSolicitudActiva >= 1) {
        setDialogMessage(
          "Hay una solicitud de preanálisis activa. Debe esperar el cierre de la misma para poder realizar otra solicitud."
        );
        setDialogOpen(true);
        return;
      }

      navigate("/Mis Solicitudes/Formulario");
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
      setDialogMessage(
        "Hubo un problema al consultar la información. Cierre la sesión y vuelva a ingresar al sistema para intentar nuevamente."
      );
      setDialogOpen(true);
    }
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleCloseJubilados = () => {
    setDialogOpenJubilados(false);
  };

  const handleCloseCotizaciones = () => {
    setDialogOpenCotizaciones(false);
  };

  const handleCloseRevalorizacion = () => {
    setDialogOpenRevalorizacion(false);
  };

  const handleGoToRevalorizacion = () => {
    setDialogOpenRevalorizacion(false);
    navigate("/Mi Informaci\u00F3n/Revalorizacion");
  };

  const actions = [
    { icon: <CurrencyExchangeIcon />, name: "Préstamos" },
    { icon: <ArticleIcon />, name: "Constancias" },
    { icon: <SavingsIcon />, name: "Cotizaciones" },
    { icon: <ForwardToInboxIcon />, name: "Quejas y Sugerencias" },
  ];

  const isJubiladoOPensionado = [
    "JUBILADO",
    "Jubilado",
    "jubilado",
    "PENSIONADO",
    "Pensionado",
    "pensionado",
  ].includes(sessi.sessionData.estado);

  const isActivo = ["ACTIVO", "Activo", "activo"].includes(
    sessi.sessionData.estado
  );

  const initialCards = [
    {
      id: 1,
      title: "Solicitar Preanálisis de Préstamo",
      description:
        "Inicia el proceso para tu preanálisis de préstamo adjuntando la documentación requerida y descubre tu monto a otorgar.",
      image: preanalisis,
      action: handleButtonClickPreanalisis,
      buttonText: "Solicitar Preanálisis Aquí",
    },
    ...(isActivo
      ? [
          {
            id: 2,
            title: "Visualizar Saldo de Cotizaciones",
            description:
              "Visualiza tu saldo cotizado, promedio de salarios cotizados, pensión aproximada y tus últimos salarios cotizados.",
            image: cotizaciones,
            action: () => {
              navigate("/Mi Información/Cotizaciones");
            },
            buttonText: "Ir a mis cotizaciones",
          },
        ]
      : []),
    ...(SHOW_REVALORIZACION_CARD && isJubiladoOPensionado 
      ? [
          {
            id: 3,
            title: "Consulta de Revalorización de Pensión",
            description:
              "Consulta la revalorización de tu pensión por año, visualizando la pensión anterior, el valor revalorizado y el nuevo monto.",
            image: proyectados,
            action: () => {
              navigate("/Mi Información/Revalorizacion");
            },
            buttonText: "Consultar Revalorización",
          },
        ]
      : []),
    ...(isJubiladoOPensionado
      ? [
          {
            id: 4,
            title: "Constancia para Jubilados y Pensionados",
            description:
              "Descarga tu constancia de pensionado fácilmente, sin complicaciones, desde nuestro portal en tan solo un clic.",
            image: constancias,
            action: () => {
              navigate("/Mis Solicitudes/ConstanciaJubilacion");
            },
            buttonText: "Descargar Constancia Aquí",
          },
        ]
      : []),
    {
      id: 5,
      title: "Constancia de Historial de Cotizaciones",
      description:
        "Documento oficial que detalla los aportes realizados por un cotizante. Se entrega exclusivamente en formato físico en la oficina o regional seleccionada durante la solicitud. ",
      image: constanciacotizaciones,
      action: () => {
        navigate("/Mis Solicitudes/ConstanciaHistorialCotizaciones");
      },
      buttonText: "Solicitar Constancia Aquí",
    },
    /*{
      id: 6,
      title: "Constancia para el Pago de Prestaciones",
      description:
        "Solicitud de constancia para procesos de prestaciones, cartera y cobro.",
      image: constanciaPrestaciones,
      action: () => {
        navigate("/Mis Solicitudes/SolicitudConstanciaPrestaciones");
      },
      buttonText: "Solicitar Constancia Aquí",
    },
    /*{
      id: 5,
      title: 'Constancia de Saldos Proyectados',
      description:
        'Genere su número de recibo, con el cual podrá realizar el pago de L.200 en cualquier agencia de Banco Atlántida a nivel nacional.',
      image: proyectados,
      action: () => {
        navigate('/Mis Solicitudes/ConstanciaSaldoProyectado');
      },
      buttonText: 'Solicitar Constancia Aquí',
    },
    {
      id: 6,
      title: 'Constancia de No Tener Préstamo Activo',
      description:
        'Genere su número de recibo, con el cual podrá realizar el pago de L.200 en cualquier agencia de Banco Atlántida a nivel nacional.',
      image: noprestamos,
      action: () => {
        navigate('/Mis Solicitudes/ConstanciaNoTenerPrestamo');
      },
      buttonText: 'Solicitar Constancia Aquí',
    },
    {
      id: 7,
      title: 'Constancia para Embajadas',
      description:
        'Genere su número de recibo, con el cual podrá realizar el pago de L.200 en cualquier agencia de Banco Atlántida a nivel nacional.',
      image: embajada,
      action: () => {
        navigate('/Mis Solicitudes/ConstanciaEmbajada');
      },
      buttonText: 'Solicitar Constancia Aquí',
    },*/
    {
      id: 8,
      title: "Constancia Razonada",
      description:
        "La constancia razonada es un documento que contiene el tiempo de servicio registrado por una persona en una institución, y se emite en aquellos casos excepcionales en los que la entidad no dispone de información suficiente sobre el participante.",
      image: razonada,
      action: () => {
        /*if (
          ['JUBILADO', 'Jubilado', 'jubilado', 'PENSIONADO', 'pensionado', 'Pensionado'].includes(sessi.sessionData.estado)
        ) {*/
        navigate("/Mis Solicitudes/ConstanciaRazonada");
        /*} else {
          setDialogOpenJubilados(true);
        }*/
      },
      buttonText: "Solicitar Constancia Aquí",
    },
    {
      id: 9,
      title: "Envío de Quejas y Sugerencias",
      description:
        "Ayúdanos a seguir mejorando al compartir tus quejas o sugerencias sobre los servicios del INJUPEMP.",
      image: qys,
      action: () => navigate("/Mis Solicitudes/QuejasSugerencias"),
      buttonText: "Enviar Queja o Sugerencia Aquí",
    },
  ];

  useEffect(() => {
    const cambiarPwStorage = localStorage.getItem("cambiarPw");
    if (!cambiarPwStorage) {
      localStorage.setItem("cambiarPw", sessi.sessionData.cambiarPw);
    } else {
      sessi.sessionData.cambiarPw = cambiarPwStorage;
    }

    if (sessi.sessionData.cambiarPw === 0) {
      navigate("/CambioClave");
    }
  }, []);

  useEffect(() => {
    const noticeKey = `${REVALORIZACION_NOTICE_STORAGE_KEY}-${
      sessi.sessionData.id || sessi.sessionData.identidad || "usuario"
    }`;

    if (!SHOW_REVALORIZACION_CARD || !isJubiladoOPensionado) return;
    if (Number(sessi.sessionData.cambiarPw) === 0) return;
    if (sessionStorage.getItem(noticeKey) === "true") return;

    sessionStorage.setItem(noticeKey, "true");
    setDialogOpenRevalorizacion(true);
  }, [
    isJubiladoOPensionado,
    sessi.sessionData.cambiarPw,
    sessi.sessionData.id,
    sessi.sessionData.identidad,
  ]);

  const handleButtonClick = () => {
    navigate("/Mis Solicitudes/SeleccionarSolicitud");
  };

  const handleVideoClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const [open, setOpen] = React.useState(false);
  const handleOpenDial = () => setOpen(true);
  const handleCloseDial = () => setOpen(false);
  const [filteredCards, setFilteredCards] = useState(initialCards); // Cards filtrados

  return (
    <>
      <Grid
        container
        direction="column"
        alignItems="center"
        marginTop={isMobile ? 1 : 4}
      >
        <div>
          <Typography
            variant="h5"
            fontWeight="bold"
            textAlign="center"
            gutterBottom
          >
            Nuestros servicios disponibles:
          </Typography>
        </div>
      </Grid>

      {isMobile && (
        <Grid
          container
          direction="column"
          alignItems="center"
          marginTop={isMobile ? 1 : 4}
        >
          <div>
            <Typography textAlign="center" style={{ fontSize: "12px" }}>
              Pulse "Ver Más" para avanzar y visualizar más servicios
              disponibles y "Atrás" para retroceder.
            </Typography>
          </div>
        </Grid>
      )}

      <Grid container direction="column" alignItems="center" marginTop={4}>
        <TextField
          label="Buscar"
          placeholder="Ingrese el nombre del servicio"
          variant="outlined"
          value={searchQuery}
          onChange={handleSearchChange}
          fullWidth
          sx={{ maxWidth: "500px", mb: 3 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          helperText={
            searchQuery &&
            (filteredCards.length > 0
              ? `Resultados Encontrados: ${filteredCards.length}`
              : "No se encontraron resultados")
          }
        />
      </Grid>

      {/* Mostrar mensaje si no hay resultados */}
      {filteredCards.length === 0 && searchQuery !== "" && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Typography variant="h6" color="text.secondary">
            No se encontraron resultados para "{searchQuery}"
          </Typography>
        </Box>
      )}

      <ScrollableCardRow
        cards={filteredCards}
        startIndex={startIndex}
        setStartIndex={setStartIndex}
      />

      {filterActive && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Button
            variant="contained"
            sx={{
              color: "#FFFFFF",
              backgroundColor: "var(--color-brand-primary)",
              "&:hover": {
                borderColor: "#FFFFFF",
                backgroundColor: "#89CFE0",
                color: "#FFFFFF",
              },
            }}
            onClick={handleClearFilters}
          >
            Eliminar Filtros
          </Button>
        </Box>
      )}

      <Grid item container justifyContent="center" marginTop={isMobile ? 4 : 5}>
        <Alert
          severity="info"
          icon={false}
          // sx={{ backgroundColor: "#f0f0f0", color: "black" }}
          sx={{
            height: "auto", // o un valor fijo como "60px" si prefieres
            minHeight: "40px", // ajusta según la altura de tu alerta original
            backgroundColor: "transparent",
          }}
        ></Alert>
      </Grid>
      <Grid
        item
        container
        justifyContent="center"
        marginTop={isMobile ? 0 : 2}
        marginBlock={isMobile ? 5 : 3}
      >
        <Tooltip
          title="Ver Video Tutorial"
          arrow
          placement={!isMobile ? "right" : "bottom"}
        >
          <Paper elevation={4}>
            <Box
              sx={{
                position: "relative",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                "&:hover img": {
                  filter: "brightness(0.7)", // Oscurecer la imagen
                },
                "&:hover .play-button": {
                  width: "70px", // Ajustar el tamaño
                  height: "70px", // Ajustar el tamaño
                  boxShadow: "0 6px 15px rgba(0, 0, 0, 0.7)",
                },
              }}
              onClick={handleVideoClick}
            >
              <img
                src={previa}
                alt="Previo"
                style={{
                  width: "100%",
                  maxWidth: !isMobile ? "580px" : "300px",
                  height: "auto",
                }}
              />
              <IconButton
                className="play-button"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "50px", // Tamaño fijo
                  height: "50px", // Tamaño fijo
                  transform: "translate(-50%, -50%)",
                  background: "linear-gradient(to bottom, black, grey)",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.5)",
                  transition: "width 0.2s, height 0.2s, box-shadow 0.2s", // Suavizar la transición
                }}
                color="primary"
              >
                <PlayArrowIcon sx={{ color: "#FFFFFF", fontSize: "40px" }} />{" "}
                {/* Ajustar el tamaño del ícono */}
              </IconButton>
            </Box>
          </Paper>
        </Tooltip>
      </Grid>

      <Box>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          PaperProps={{
            style: {
              border: "none",
              borderRadius: 0,
            },
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogContent style={{ padding: 0 }}>
            <ReactPlayer
              url={videoUrl}
              width="100%"
              height={isMobile ? "200px" : "400px"}
              controls
              playing
            />
          </DialogContent>
        </Dialog>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          onClick={handleButtonClick}
          startIcon={<PlaylistAddIcon sx={{ color: "#FFFFFF" }} />}
          variant="outlined"
          sx={{
            borderColor: "var(--color-brand-primary)",
            color: "#FFFFFF",
            backgroundColor: "var(--color-brand-primary)",
            "&:hover": {
              borderColor: "#FFFFFF",
              backgroundColor: "#89CFE0",
              color: "#FFFFFF",
            },
          }}
          size="large"
        >
          Crear Solicitud
        </Button>
      </Box>

      {/*!isMobile && (
        <Grid
          marginTop={isMobile ? 10 : 1}
          container
          item
          justifyContent={isMobile ? 'center' : 'flex-end'}
          style={{
            position: 'absolute',
            top: 0,
            right: isMobile ? -90 : 0,
            opacity: 0.1,
            zIndex: -1,
          }}
        >
          <img src={escudo} alt="Escudo" style={{ width: isMobile ? '100vw' : '33vw' }} />
        </Grid>)*/}

      <Box
        sx={{
          position: "fixed", // Asegura que sea flotante respecto al viewport
          bottom: 16, // Espaciado desde la parte inferior de la pantalla
          right: 16, // Espaciado desde la parte derecha de la pantalla
          zIndex: 10, // Asegura que esté por encima de otros elementos
        }}
      >
        <Backdrop open={open} />
        <SpeedDial
          ariaLabel="SpeedDial tooltip example"
          sx={{ position: "absolute", bottom: 16, right: 16 }}
          icon={<SearchIcon />}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              tooltipOpen
              onClick={() => {
                handleFilter(action.name);
                setOpen(false);
              }}
            />
          ))}
        </SpeedDial>
      </Box>

      <Dialog open={dialogOpenJubilados} onClose={handleCloseJubilados}>
        <DialogTitle>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ErrorIcon style={{ color: "var(--color-brand-primary)", marginRight: "8px" }} />
            <Typography variant="h6">Atención</Typography>
          </div>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Este servicio es solo para jubilados y pensionados.
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button
            onClick={handleCloseJubilados}
            color="primary"
            variant="contained"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dialogOpenCotizaciones} onClose={handleCloseCotizaciones}>
        <DialogTitle>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ErrorIcon style={{ color: "var(--color-brand-primary)", marginRight: "8px" }} />
            <Typography variant="h6">Atención</Typography>
          </div>
        </DialogTitle>
        <DialogContent>
          <Typography>
            La visualización de cotizaciones es solo para participantes activos.
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button
            onClick={handleCloseCotizaciones}
            color="primary"
            variant="contained"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={dialogOpenRevalorizacion}
        onClose={handleCloseRevalorizacion}
        TransitionComponent={Zoom}
        transitionDuration={420}
        keepMounted
        maxWidth={false}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "visible",
            width: "auto",
            maxWidth: "calc(100vw - 24px)",
            m: { xs: 1.5, sm: 2 },
          },
        }}
      >
        <Card
          sx={{
            width: { xs: "calc(100vw - 28px)", sm: 500, md: 560 },
            maxWidth: "calc(100vw - 28px)",
            mx: "auto",
            borderRadius: 1,
            border: "2px solid rgba(255, 255, 255, 0.96)",
            outline: "3px solid rgba(0, 0, 0, 0.56)",
            overflow: "hidden",
            boxShadow:
              "0 26px 70px rgba(0, 0, 0, 0.38), 0 0 24px rgba(0, 0, 0, 0.2)",
          }}
        >
          <CardMedia
            component="img"
            height={isMobile ? "220" : "300"}
            image={proyectados}
            alt="Consulta de Revalorizacion de Pension"
            sx={{ objectFit: "cover" }}
          />
          <CardContent sx={{ px: { xs: 2.5, sm: 4 }, pt: 3, pb: 1.25 }}>
            <Typography
              gutterBottom
              variant={isMobile ? "h6" : "h5"}
              sx={{ lineHeight: 1.25 }}
            >
              {"Consulta de Revalorizaci\u00F3n de Pensi\u00F3n"}
            </Typography>
            <Typography
              variant={isMobile ? "body2" : "body1"}
              color="text.secondary"
              textAlign="justify"
            >
              {
                "Consulta la revalorizaci\u00F3n de tu pensi\u00F3n por a\u00F1o, visualizando la pensi\u00F3n anterior, el valor revalorizado y el nuevo monto."
              }
            </Typography>
          </CardContent>
          <CardActions
            sx={{
              justifyContent: "center",
              flexDirection: "column",
              gap: 1,
              px: { xs: 2.5, sm: 4 },
              pb: 2.25,
            }}
          >
            <Button
              variant="contained"
              disableElevation
              size="small"
              onClick={handleGoToRevalorizacion}
              sx={{
                width: { xs: "100%", sm: "auto" },
                minHeight: 46,
                color: "var(--color-white) !important",
                backgroundColor: "var(--color-brand-primary)",
                fontWeight: 700,
                px: { xs: 2, sm: 3 },
                letterSpacing: 0,
                lineHeight: 1.2,
                whiteSpace: "nowrap",
                WebkitFontSmoothing: "antialiased",
                MozOsxFontSmoothing: "grayscale",
                "&:hover": {
                  borderColor: "var(--color-white)",
                  backgroundColor: "var(--color-brand-secondary)",
                  color: "var(--color-white) !important",
                },
                "&:focus, &:active": {
                  color: "var(--color-white) !important",
                },
              }}
            >
              {"Consultar Revalorizaci\u00F3n"}
            </Button>
            <Button
              size="small"
              onClick={handleCloseRevalorizacion}
              sx={{
                color: "text.secondary",
                textTransform: "none",
                minHeight: 28,
              }}
            >
              Ahora no
            </Button>
          </CardActions>
        </Card>
      </Dialog>

      <Dialog open={dialogOpen} onClose={handleClose}>
        <DialogTitle>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ErrorIcon style={{ color: "var(--color-brand-primary)", marginRight: "8px" }} />
            <Typography variant="h6">Atención</Typography>
          </div>
        </DialogTitle>
        <DialogContent>
          <Typography>{dialogMessage}</Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button onClick={handleClose} color="primary" variant="contained">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
